import React from "react";

import { Flex, Select, SelectProps } from "antd";

import { Icon } from "components";

export interface SelectSegmentedProps extends Omit<SelectProps, "optionRender"> {
  options: { label: string; value: string | number }[];
}

export const SelectSegmented = ({ className, ...props }: SelectSegmentedProps) => (
  <div className={`${className ?? ""}`}>
    <Select
      className="select-segmented"
      suffixIcon={<Icon iconName="tabler/chevron-down" size={24} />}
      {...props}
      optionRender={(ori) => (
        <Flex align="center" justify="flex-start" className="select-segmented-option" gap={8}>
          {ori.label} {ori.value === props.value ? <Icon iconName={"tabler/circle-check"} size={24} /> : null}
        </Flex>
      )}
    />
  </div>
);
